import zhongbiaogg from './zhongbiaogg';
import zbhxrgs from './zbhxr-gs'
export default {
    path: 'dingbiao',
    component: () => import(/*webpackChunkName: 'bidding-dingbiao'*/ '@layout/empty'),
    children: [
        zbhxrgs,
        zhongbiaogg,
    ]
}